<script lang="ts">
    import type Blocks from '@/schemas/public/Blocks.ts';
    import type {Field, RelatedListButtonType, Document} from "@/types/types";
    import FormContainer from "@/components/Form/FormContainer.svelte";
    import Debug from "@/components/Debug.svelte";
    import {useForm} from '@inertiajs/svelte';
    import InlineEditable from "@/components/Inputs/InlineEditable.svelte";
    import FormBlock from "@/components/Form/FormBlock.svelte";
    import AppLayout from "@/layouts/AppLayout.svelte";
    import {FileText, Pencil, Plus, Trash} from "lucide-svelte";
    import {Accordion, AccordionContent, AccordionItem, AccordionTrigger,} from "@/components/ui/accordion"
    import {Button} from "@/components/ui/button";
    import CreateDocumentModal from "@/components/documents/CreateDocumentModal.svelte";
    import EditDocumentModal from "@/components/documents/EditDocumentModal.svelte";
    import PreviewDocument from "@/components/documents/PreviewDocument.svelte";


    type Props = {
        document: Document;
        blocks: (Blocks & { fields: Field[] })[];
        entityFieldColumn?: string;
    };

    let {document, blocks, entityFieldColumn}: Props = $props();

    // Get the entity display name using the entityFieldColumn from the module
    const entityDisplayName = entityFieldColumn && (document as Record<string, any>)[entityFieldColumn]
        ? (document as Record<string, any>)[entityFieldColumn]
        : 'Document Details';

    let breadcrumbs = $state([
        {title: 'Documents', href: route('documents.index')},
        {title: entityDisplayName, href: route('documents.show', {document: document.id})},
    ]);

    let deleteForm = $state(useForm({}));

    let actionbuttons = $state([
        {
            title: 'Edit Document',
            href: undefined,
            onClick: openEditDocumentModal,
            icon: Pencil,
        },
        {
            title: 'Add New Document',
            href: undefined,
            icon: Plus,
            onClick: openCreateDocumentModal,
        },
        {
            title: 'Delete Document',
            actionType: 'delete',
            href: undefined,
            onClick: () => {
                $deleteForm.delete(route('documents.destroy', {document: document.id}));
            },
            icon: Trash,
        }
    ]);

    let showCreateDocumentModal = $state(false);

    function openCreateDocumentModal() {
        showCreateDocumentModal = true;
    }

    let editDocumentModal = $state(false);

    function openEditDocumentModal() {
        editDocumentModal = true;
    }

    // let showCreateSiteModal = $state(false);
    // function openCreateSiteModal(){
    //     showCreateSiteModal = true;
    // }


    let inlineFormInner: Record<string, any> = {}
    for (const block of blocks) {
        for (const field of block.fields) {
            inlineFormInner[field.column_name] = field.value;
        }
    }
    let inlineForm = $state(useForm(inlineFormInner));
    let editingFieldId: undefined | number = $state(undefined);

</script>

<svelte:head>
    <title>Document</title>
</svelte:head>
<AppLayout {breadcrumbs} {actionbuttons}>
    <FormContainer>
        {#each blocks as block}
            <FormBlock label={block.label}>
                {#each block.fields as field}
                    <InlineEditable
                        field={field}
                        bind:editingFieldId={editingFieldId}
                        error={$inlineForm.errors[field.column_name]}
                        onSave={(newValue) => {
                                                    $inlineForm[field.column_name] = newValue;
                                                    $inlineForm.put(route("documents.update", { document }), {

                                                        onSuccess: () => {
                                                            editingFieldId = undefined;
                                                        },
                                                        onError: (e) => {
                                                            console.log("Error updating field", e, field.column_name);
                                                        }
                                                    });
                                                    // editingFieldId = undefined;
                                                }
                                            }
                        record={document}
                    />
                {/each}
            </FormBlock>
        {/each}
    </FormContainer>


    <PreviewDocument {document} {blocks} />
    <!--    <Accordion type="single" collapsible>-->
    <!--        <AccordionItem value="item-1">-->
    <!--            <AccordionTrigger>-->
    <!--                Related Sites-->
    <!--                &lt;!&ndash;                <Button&ndash;&gt;-->
    <!--                &lt;!&ndash;                    onclick={openCreateSiteModal}&ndash;&gt;-->
    <!--                &lt;!&ndash;                    class="flex items-center gap-x-3 rounded-lg px-3 py-2 text-sm font-medium hover:bg-accent ">&ndash;&gt;-->
    <!--                &lt;!&ndash;                    <Plus class="h-4 w-4"/> Add Site&ndash;&gt;-->
    <!--                &lt;!&ndash;                </Button>&ndash;&gt;-->
    <!--            </AccordionTrigger>-->

    <!--            <AccordionContent>-->
    <!--                <SiteTable-->
    <!--                    view="relatedList"-->
    <!--                    relatedData={{-->
    <!--                        column : 'customer_id',-->
    <!--                        record_id : customer.id-->
    <!--                    }}-->
    <!--                />-->
    <!--            </AccordionContent>-->
    <!--        </AccordionItem>-->
    <!--    </Accordion>-->
    <CreateDocumentModal
        blocks={blocks}
        bind:show={showCreateDocumentModal}
    />


    <EditDocumentModal
        blocks={blocks}
        bind:show={editDocumentModal}
        document={document}
    />

</AppLayout>

}
